import { Component, OnInit } from '@angular/core';
import { GlobalVars } from '../../providers/globalVars';
import { Router } from '@angular/router';
import { AngularFireDatabase} from '@angular/fire/database';
import { ModalController} from '@ionic/angular';
@Component({
  selector: 'app-menu',
  templateUrl: './menu.page.html',
  styleUrls: ['./menu.page.scss'],
})
export class MenuPage implements OnInit {
  uid:any;
  notireject;
  
  constructor(public gv:GlobalVars,public router: Router,
    private modalCtrl: ModalController,
    private afDB: AngularFireDatabase) { }

  ngOnInit() {
    this.uid = this.gv.uid;
  }

  async openpage(page){
    let type = null;
    let log = null;
    let prop; //{modal:true, type:null};log = 'actchk'; 
    prop = {modal:true, type:null};
    switch(page){
      case 'pointinfo':this.router.navigate(['/pointinfo']); break;
      case 'mypoint':this.router.navigate(['/mypoint']); break;
      case 'msg':this.router.navigate(['/message']); break;
      case 'alarm':this.router.navigate(['/alarm']); break;
      case 'nickname':this.router.navigate(['/nickname']); break;
      case 'blockuser':this.router.navigate(['/blockuser']); break;
      case 'pwdchange':this.router.navigate(['/pwdchange']); break;
      case 'notice':this.router.navigate(['/notice']); log = 'noticechk'; break;
      case 'qna':this.router.navigate(['/qna']); log = 'qnachk'; break;
      case 'version':this.router.navigate(['/version']); break; 
 //     prop.currentver = this.currentver; prop.thisver = this.thisver; break;
      case 'favchlist':this.router.navigate(['/favchlist']); log = 'actchk'; break;
      case 'actrecent':this.router.navigate(['/chlistmodal','r']); log = 'actchk'; break;
      case 'actpost':this.router.navigate(['/chlistmodal','w']); log = 'actchk'; break;
      case 'actliked':this.router.navigate(['/chlistmodal','l']); log = 'actchk'; break;
      case 'actcomment':this.router.navigate(['/chlistmodal','c']); log = 'actchk'; break;
      case 'mybucket':this.router.navigate(['/mybucket']); log = 'actchk'; break;
      case 'mylevel':this.router.navigate(['/mylevel']);  log = 'levelchk'; break;
      case 'myaccount':this.router.navigate(['/account']); break;
      case 'setnoti':this.router.navigate(['/setnoti']); log = 'alarmchk'; break;
      case 'setlocal':this.router.navigate(['/setlocal']); break;
      case 'systemlog':this.router.navigate(['/systemlog']); break;
      }
    if(log)
    {
    let today = new Date();
    let todaystr = today.getFullYear() + '-' + (today.getMonth()+1>9?today.getMonth()+1:'0' + (today.getMonth()+1)) + '-' + (today.getDate()>9?today.getDate():'0'+today.getDate())
    this.afDB.database.ref('/systemlog/' + (this.uid?this.uid:'unregister') + '/event/' + todaystr + '/' + log).transaction(view=>{
      return (view || 0) + 1;
    })
    }
  }
}
